import React from "react";
import LoaderCircle from "../../utils/LoaderCircle";
/**
 *
 * @param {Element} children
 * @param {number} size
 * @param {string} classe
 * @param {string} type
 * @param {string} rounded
 * @param {string} color
 * @param {function} onClick
 * @param {boolean} loading
 * @returns button action
 */
const Button = (props) => {
  const { children, size, type, classe, color, onClick, loading, id } = props;

  let textSize, padding, btnType;

  //size
  if (size === "big") {
    textSize = "text-sm md:text-lg";
    padding = "py-5 px-6 md:px-8";
  } else if (size === "small") {
    textSize = "text-xs";
    padding = "py-4 px-5";
  } else {
    textSize = "text-sm md:text-base";
    padding = "py-5 px-4 md:py-5 lg:px-6";
  }

  if (type === "secondary")
    btnType = "bg-smoot text-secondary/50 hover:text-secondary";
  else if (type === "danger")
    btnType = "bg-red-600 text-white hover:text-red-600";
  else btnType = "bg-primary text-white hover:bg-primary-dark";

  return (
    <button
      id={id}
      onClick={onClick ? onClick : null}
      className={`${classe} ${btnType} ${textSize} ${padding} ${
        loading && "flex cursor-not-allowed items-center opacity-70"
      } animate mr-2 mb-2  inline-block rounded-lg px-5 py-5 text-xs font-medium text-white `}
    >
      {loading && (
        <LoaderCircle size="small" contentColor="light" fillColor="primary" />
      )}
      <span>{children}</span>
    </button>
  );
};

export default Button;
